<template>
  <div class="person_card_center">
    <el-row class="person_card_wrap" type="flex" justify="space-between">
      <el-col class="card_item" :span="7" :xs="24">
        <h2>长三院海外孵化器</h2>
        <div class="card_bg"></div>
        <div class="card_desc">
          <ul>
            <li>2个技术中心，位置分别位于柏林、 香港</li>
            <li>9个离岸的孵化器、12个海外的联络处</li>
          </ul>
        </div>
        <img style="" src="~@/assets/img/changsan.png" alt="" />
      </el-col>
      <el-col class="card_item" :span="7" :xs="24">
        <h2>联盟企业网络</h2>
        <div class="card_bg"></div>
        <div class="card_desc">
          <ul>
            <li>中德汽车大会、北德氢能技术与产 业发展论坛等氢能论坛</li>
            <li>联系国际氢能协会、商会 ，与佛吉 亚等建立战略合作伙伴关系</li>
          </ul>
        </div>
        <img src="~@/assets/img/lianmeng.png" alt="" />
      </el-col>
      <el-col class="card_item" :span="7" :xs="24">
        <h2>政府友好城市</h2>
        <div class="card_bg"></div>
        <div class="card_desc">
          <ul>
            <li>德国、丹麦、荷兰、西班牙等 欧洲国家联合研发合作</li>
            <li>马来西亚、沙特、阿联酋等国 推进技术转化与应用</li>
          </ul>
        </div>
        <img src="~@/assets/img/zhengfu.png" alt="" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.person_card_center {
  width: 70%;
  margin: 50px auto;
  @media screen and (max-width: 768px) {
    width: 90%;
  }
  .person_card_wrap {
    @media screen and (max-width: 768px) {
      flex-direction: column;
      justify-content: space-between;
    }
    .card_item {
      border-radius: 10px;
      background: #fff;
      border-color: rgba(0, 0, 0, 0.09);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
      img {
        width: 100%;
        height: 300px;
        @media screen and (max-width: 768px) {
          height: 240px;
        }
      }
      color: #fff;
      padding: 30px;
      & {
        @media screen and (max-width: 768px) {
          margin-top: 1.5rem;
        }
      }
      h2 {
        color: #000;
        font-size: 30px;
        @media screen and (max-width: 768px) {
          font-size: 24px;
        }
      }
      p {
        font-size: 18px;
        @media screen and (max-width: 768px) {
          font-size: 13px;
          padding: 10px 0;
        }
      }
      @media screen and (max-width: 768px) {
        height: auto;
        padding: 20px;
        background-size: cover;
        color: #000;
      }
      .card_bg {
        width: 35px;
        height: 5px;
        margin-top: 10px;
        background: #000;
        @media screen and (max-width: 768px) {
          width: 20px;
          height: 3px;
        }
      }
      .card_desc {
        color: #000;
        margin-top: 30px;
        margin-bottom: 20px;
        line-height: 1.5rem;
        font-size: 20px;
        @media screen and (max-width: 768px) {
          color: #000;
          font-size: 15px;
        }
      }
    }
  }
}
</style>